import React, { useEffect, useRef, useState } from 'react';
import { withRouter, useHistory, useLocation } from "react-router-dom";

import { store } from 'react-notifications-component';

import api from '../../services/api';
import identifyErrorMenssage from '../../services/identifyErrorMenssage';

import InputV3 from '../../components/input/novo/input_v3';

import SetaCinza from '../../assets/icons/icon-right-gray.svg'
import SetaBranca from '../../assets/icons/icon-right-white.svg'
import LogoBranca from '../../assets/logo-agroreceita-branco.svg'
import CreditCardMobile from '../../assets/icons/icon-credit-card-white.svg'

import * as S from './styles';
import { theme } from '../../styles/theme';
import { BodyM, H3, TaglineM, TaglineP } from '../../styles/stylesTypography';
import maintainUtm from '../../services/maintainUtm';

export const compendioG = "@compendioG";

const CadastroEmail = ({ location, ...props }) => {
    const [width, setWidth] = useState(window.innerWidth);

    const [nome, setNome] = useState(location.state?.nome || '');
    const [email, setEmail] = useState(location.state?.email || '');

    const [nomeErrorMessage, setNomeErrorMessage] = useState('');
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [obs, setObs] = useState(location.state?.obs || '');

    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [width]);

    const handleNomeChange = (e) => {
        const newNome = e.target.value;

        const trimmedNome = newNome.replace(/\s+/g, ' ');

        setNome(trimmedNome);
        setNomeErrorMessage('');
    };

    const handleEmailChange = (e) => {
        const newEmail = e.target.value;

        setObs('email')

        setEmailErrorMessage('');

        const trimmedEmail = newEmail.trim();
        
        setEmail(trimmedEmail)

        if (validateEmail(newEmail) === '') {
            setEmailErrorMessage('');
        }
    };

    const validateNome = (nome) => {
        if (!nome || nome === undefined) {
            return true;
        }

        const regex = /^[A-Za-zÀ-ú\s]+$/;

        if (nome.length < 4) {
            store.addNotification({
            title: "Erro!",
            message: 'O nome deve ter pelo menos 4 caracteres.',
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
                duration: 4000,
                onScreen: true
            }
        });
        
        setNomeErrorMessage('O nome deve ter pelo menos 4 caracteres.');
        return 'O nome deve ter pelo menos 4 caracteres.';
        }

        if (!regex.test(nome)) {
            return null;
        }
        return '';
    };

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]+(\.[a-zA-Z]+)*$/;
    
        // Evita acessar .length em null quando o usuário ainda está digitando
        const repeatedDomains = email ? (email.match(/\.(com|com\.br|org|org\.br|yahoo|net)/g) || []) : [];

        if (!regex.test(email) || repeatedDomains.length > 1) {
            return null;
        }
        return '';
    };

    const getParams = () => {
        const utm_id = decodeURIComponent(new URLSearchParams(window.location.search).get('utm_id'));
        const utm_source = decodeURIComponent(new URLSearchParams(window.location.search).get('utm_source'));
        const utm_medium = decodeURIComponent(new URLSearchParams(window.location.search).get('utm_medium'));
        const utm_campaign = decodeURIComponent(new URLSearchParams(window.location.search).get('utm_campaign'));
        const button = decodeURIComponent(new URLSearchParams(window.location.search).get('button'));
        const _ga = decodeURIComponent(new URLSearchParams(window.location.search).get('_ga'));

        const payload = {
            utm_id: utm_id && utm_id !== 'null' ? utm_id : 0,
            utm_source: utm_source && utm_source !== 'null' ? utm_source : 'orgânico',
            utm_medium: utm_medium && utm_medium !== 'null' ? utm_medium : 'orgânico',
            utm_campaign: utm_campaign && utm_campaign !== 'null' ? utm_campaign : 'orgânico',
            button: button && button !== 'null' ? button : '0',
            _ga: _ga && _ga !== 'null' ? _ga : '',
        };

        return payload;
    };

    const validaEmail = async (nome, email, obs) => {
        try {
            if (email) {
                setLoading(true);
                const response = await api.post(`/cadastro/validaEmail`, { email: email });

                if (response) {
                    setEmailErrorMessage('');

                    const utmParams = getParams();

                    history.push({
                        pathname: "/cadastro-completo",
                        state: { nome, email, utmParams, obs }
                    });
                }
            }

            return { success: true };
        } catch (error) {
            const apiErrorMessage = identifyErrorMenssage(error, 'Falha ao validar o e-mail informado.');

            setEmailErrorMessage(apiErrorMessage);
            
            store.addNotification({
                title: "Erro!",
                message: apiErrorMessage,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });

            return { error: apiErrorMessage };
        } finally {
            setLoading(false);
        }
    };

    const handleContinuarClick = async () => {
        const nomeValidationError = validateNome(nome);
        const emailValidationError = validateEmail(email);

        setNomeErrorMessage(nomeValidationError);
        setEmailErrorMessage(emailValidationError);

        if (!nomeValidationError && !emailValidationError) {
            setTimeout(() => validaEmail(nome, email, obs), 0);
        }
    };

    
    useEffect(() => {
        const emailValidationError = validateEmail(email);

        setIsButtonDisabled(nome.length < 4 || emailValidationError !== '');
    }, [nome, email]);

    useEffect(() => {
        const { nome, email, obs, emailValidationForm } = location.state;
        setNome(nome);
        setEmail(email);
        setObs(obs);

        if (emailValidationForm === false ) {
            if (nome) {
                validaEmail(nome, email, obs);
            }
        }
   }, [location.state]);

    return (
        <S.Container>
            <S.Wrapper>
                <S.Description>
                    <img src={LogoBranca} alt='Logo AgroReceita Branco' />

                    <H3 color={theme.colors.white.Branco}>Comece seus 14 dias de teste grátis agora!</H3>

                    <BodyM color={theme.colors.gray.Cinza_9}>Faça seu cadastro e aproveite todas<br /> as funções do plano PRO.</BodyM>

                    <S.NoCreditCard>
                        <img src={CreditCardMobile} alt='Ícone de cartão de crédito com risco' />

                        <TaglineP color={theme.colors.white.Branco} fontWeight={800}>Não é necessário cartão de crédito</TaglineP>
                    </S.NoCreditCard>
                </S.Description>

                <S.Form>
                    <S.ContainerInputs>
                        <InputV3
                            id='nome'
                            type="nome"
                            label="nome"
                            floatingLabel="Nome"
                            placeholder=""
                            errorInfo={nomeErrorMessage}
                            hasError={!!nomeErrorMessage}
                            isDisabled={false}
                            value={nome}
                            onChange={handleNomeChange}
                            onBlur={() => validateNome(nome)}
                            handleClear={() => setNome('')}
                        />

                        <InputV3
                            id='email'
                            type='email'
                            label="e-mail"
                            floatingLabel="E-mail"
                            placeholder=""
                            errorInfo={emailErrorMessage}
                            hasError={!!emailErrorMessage}
                            isDisabled={false}
                            value={email}
                            onChange={handleEmailChange}
                            handleClear={() => setEmail('')}
                        />
                    </S.ContainerInputs>

                    <S.ContainerButtons>
                        <a href={`/login${maintainUtm()}`}>
                            <S.ButtonLogin>
                                <TaglineM color={theme.colors.blue.Azul_link} fontWeight={800}>fazer login</TaglineM>
                            </S.ButtonLogin>
                        </a>

                        <S.FormButton
                            type="submit"
                            disabled={isButtonDisabled}
                            onClick={handleContinuarClick}
                        >
                            {loading ? (
                                <S.Loading disabled={isButtonDisabled} />
                            ) : (
                                <>
                                    <TaglineM fontWeight={800}>Continuar</TaglineM>

                                    <img src={isButtonDisabled ? SetaCinza : SetaBranca} alt='Seta' />
                                </>
                            )} </S.FormButton>
                    </S.ContainerButtons>
                </S.Form>
            </S.Wrapper>
        </S.Container>
    );
};

export default withRouter(CadastroEmail);
